<script>
export default {
    // state
    props: {
        isDisabled: Boolean,
        isPrimary: Boolean,
        isSecondary: Boolean,
        type: {
            default: 'button',
            type: String,
        },
    },
}
</script>

<template>
    <button
        class="vca-vue-btn"
        v-bind="{ type, disabled: isDisabled ? '' : null }"
        v-bind:class="{
            'vca-vue-btn--primary': isPrimary && !isDisabled,
            'vca-vue-btn--secondary': isSecondary && !isDisabled,
        }"
    >
        <slot></slot>
    </button>
</template>

<style>
@reference "../../main.css";

.vca-vue-btn {
    @apply
        tw:flex-1
        tw:px-4
        tw:py-2
        tw:w-full
        tw:h-fit
        tw:text-base
        tw:font-medium
        tw:text-999
        tw:whitespace-nowrap
        tw:bg-transparent
        tw:border
        tw:border-solid
        tw:border-ccc
        tw:appearance-none
        tw:hover:bg-eee
    ;
}
.vca-vue-btn:disabled {
    @apply
        tw:text-ccc
        tw:bg-eee
        tw:border-eee
        tw:hover:bg-eee
    ;
}
.vca-vue-btn--primary {
    @apply
        tw:text-white
        tw:border-vacatia-blue
        tw:bg-vacatia-blue
        tw:hover:bg-vacatia-blue-light
    ;
}
.vca-vue-btn--secondary {
    @apply
        tw:text-vacatia-blue
        tw:border-vacatia-blue
        tw:hover:bg-vacatia-blue-lightest
    ;
}
</style>
